import { Injectable } from '@angular/core';
import { CookieService, CookieDict, CookieOptions } from 'ngx-cookie';

@Injectable({
  providedIn: 'root',
})
export class NgxCookieService {
  constructor(private _cookieService: CookieService) {}

  // ngx-cookie methods

  public get(key: string): string | undefined {
    return this._cookieService.get(key);
  }

  public getAll(): CookieDict {
    return this._cookieService.getAll();
  }

  public getObject(key: string): Record<string, unknown> | undefined {
    return this._cookieService.getObject(key) as Record<string, unknown>;
  }

  public hasKey(key: string): boolean {
    return this._cookieService.hasKey(key);
  }

  public put(key: string, value?: string, options?: CookieOptions): void {
    return this._cookieService.put(key, value, options);
  }

  public putObject(key: string, value: Record<string, unknown>, options?: CookieOptions): void {
    return this._cookieService.putObject(key, value, options);
  }

  public remove(key: string, options?: CookieOptions): void {
    return this._cookieService.remove(key, options);
  }

  public removeAll(): void {
    return this._cookieService.removeAll();
  }

  // Custom methods

  public getOrSetBooleanValue(name: string, value?: boolean, options = {}): boolean | void {
    if (value == null) {
      return this._cookieService.get(name) === 'true';
    }
    return this._cookieService.put(name, value.toString(), options);
  }
}
